import * as React from 'react';
import {
    PageSection,
    PageSectionVariants,
    Text,
    TextContent,
    Title,
} from '@patternfly/react-core';
import {ArrowIcon} from "@patternfly/react-icons";
import { Page } from "@keycloak/keycloak-account-ui";
import { useTranslation } from "react-i18next";

export function DeleteMyAccountPage(): React.ReactNode {
    const { t } = useTranslation();
    return <Page title={t("deleteMyAccountTitle")} description={t("deleteMyAccountIntroMessage")}>
        <PageSection variant={PageSectionVariants.light} padding={{ default: 'noPadding' }}>
            <TextContent>
                <Title size="xl" headingLevel="h2">
                    {t("deleteMyAccountHeading")}
                </Title>
                <Text>
                    <Text
                        component="a"
                        target="_blank"
                        rel="noreferrer noopener"
                        href={t("contactPageHref")}
                    >
                        {t("goToContactPage")}&nbsp;<ArrowIcon />
                    </Text>
                </Text>
            </TextContent>
        </PageSection>
    </Page>
}